import { render, staticRenderFns } from "./accountManage.vue?vue&type=template&id=36cb1820&scoped=true&"
import script from "./accountManage.vue?vue&type=script&lang=js&"
export * from "./accountManage.vue?vue&type=script&lang=js&"
import style0 from "./accountManage.vue?vue&type=style&index=0&id=36cb1820&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cb1820",
  null
  
)

export default component.exports